import { render, staticRenderFns } from "./btn-text-quarternary.vue?vue&type=template&id=675127ec&scoped=true"
import script from "./btn-text-quarternary.vue?vue&type=script&lang=js"
export * from "./btn-text-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675127ec",
  null
  
)

export default component.exports